import { PaginationProps, SortDirection } from '../../utilities'
import {
  ProductProjectSalesDTO,
  ProjectProductStatDTO
} from '../../models'
import { PieSegment } from '../StatisticsPageStore'
import { StatsTableEntityObject } from '../StatsBaseTableStore'

export enum StatsViewersTableSortProps {
    TOTAL_WATCH = 'Total watch time',
    TOTAL_INTERACTION = 'Total interaction time',
    ADD_EXPENSES = 'Ad expenses',
    PURCHASE_REVENUE = 'Purchase revenue',
    ADD_REVENUE = 'Ad revenue'

}

export const statsViewersTableInitialPaginationProps: PaginationProps<StatsViewersTableSortProps> = {
  page: 0,
  size: 6,
  sortDirection: SortDirection.ASC,
  sortProp: StatsViewersTableSortProps.TOTAL_WATCH,
  totalElements: 0,
  totalPages: 0
}

export type ProductProjectViewersStat = Partial<ProjectProductStatDTO> &
    Partial<ProductProjectSalesDTO>

export type StatsTableEntity = {
    mainEntity: StatsTableEntityObject
    primaryCorrespondingEntities: StatsTableEntityObject[]
    primaryCorrespondingEntitiesCount: number
    secondaryCorrespondingEntities?: StatsTableEntityObject[]
    secondaryCorrespondingEntitiesCount?: number
    stats: {
        totalWatch: number
        totalVovWatch: number
        totalVovInteraction: number
        totalInteraction: number
        totalPageInteraction: number
        addExpenses: number
        purchases: number
    }
    bestItemPrimary?: PieSegment['bestItem']
    bestItemSecondary?: PieSegment['bestItem']
    children?: StatsTableEntity[]
}
